import { useState, useEffect } from 'react';
import { newGetCategory } from '../../../api/categoryAPI';

export const useCategories = (rootCategoryId?: number) => {
    const [categories, setCategories] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    // 현재 categories가 어느 rootCategoryId의 데이터인지 추적 (보드 전환 시 stale 데이터 구분용)
    const [loadedRootId, setLoadedRootId] = useState<number | undefined>(undefined);

    useEffect(() => {
        let active = true;

        const fetchCategories = async () => {
            if (!rootCategoryId) {
                setCategories([]);
                setLoadedRootId(undefined);
                return;
            }

            setLoading(true);
            try {
                const response = await newGetCategory(rootCategoryId);
                if (!active) return;
                setCategories(response || []);
                setLoadedRootId(rootCategoryId);
            } catch (error) {
                console.error('카테고리 목록 조회 실패:', error);
            } finally {
                if (active) setLoading(false);
            }
        };

        fetchCategories();

        return () => {
            active = false;
        };
    }, [rootCategoryId]);

    return { categories, loading, loadedRootId };
};
